var SharedUIModule = (function () {
    function SharedUIModule() {
    }
    return SharedUIModule;
}());
export { SharedUIModule };



// WEBPACK FOOTER //
// ./src/component-ui/index.ts.pre-build-optimizer.js